import DescriptionIcon from '@mui/icons-material/Description';
import { Avatar, Box, Button, Card, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
interface IFormulario {
  uuid: string;
  status: number;
  name: string;
  formulario: string;
  hideEditButton?: boolean;
}

export default function CardFormularioStatus({
  uuid,
  status,
  name,
  formulario,
  hideEditButton = false,
}: IFormulario): JSX.Element {
  const navigate = useNavigate();
  const formStatus = {
    1: {
      color: 'blue',
      text: 'Novo',
    },
    2: {
      color: 'orange',
      text: 'Rascunho',
    },
    3: {
      color: 'darkgreen',
      text: 'Cadastrado',
    },
    4: {
      color: 'darkgoldenrod',
      text: 'Enviado para Aprovação',
    },
  };

  const statusAtual = formStatus[status as keyof typeof formStatus];

  return (
    <Card
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2, // Adiciona padding interno
        boxShadow: 3, // Adiciona uma sombra sutil
        borderRadius: 2, // Bordas arredondadas
      }}
    >
      {/* Ícone à Esquerda */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          variant='rounded'
          sx={{
            bgcolor: '#0048B6', // Cor de fundo cinza claro
            width: 60,
            height: 60,
            mr: 2, // Margem à direita
          }}
        >
          <DescriptionIcon fontSize='large' />
        </Avatar>

        {/* Informações Centrais */}
        <Box>
          <Typography variant='h6' component='div' fontWeight='bold'>
            {name}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='body1' component='span'>
              Situação:
            </Typography>
            <Typography
              variant='body1'
              component='span'
              fontWeight='bold'
              sx={{ color: statusAtual.color, ml: 0.5 }} // Cor verde e margem à esquerda
            >
              {statusAtual.text}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Botões à Direita */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Button
          variant='outlined'
          size='medium'
          disabled={status === 1}
          onClick={() => {
            navigate(`/pacote-de-formularios/${formulario}/visualizar/${uuid}`);
          }}
        >
          Visualizar
        </Button>
        {!hideEditButton && (
          <Button
            variant='contained'
            sx={{ backgroundColor: '#0048B6' }}
            size='medium'
            disabled={status === 4}
            onClick={() => {
              navigate(`/pacote-de-formularios/${formulario}/editar/${uuid}`);
            }}
          >
            {status === 1 ? 'Preencher' : 'Editar'}
          </Button>
        )}
      </Box>
    </Card>
  );
}
